import {Project} from 'airship/clients/wallet/types'

export enum Urgency {
  Low = 'low',
  Medium = 'medium',
  Highest = 'highest',
  Urgent = 'urgent',
}

export interface Context {
  project?: Project
}

export interface DetailsData {
  appName: string
  url: string
  appKey: string
}

export type UrgencySelectorItem = {
  id: string
  label: string
}

export type ContactSupportDetails = {
  subject: string | undefined
  issueDescription: string | undefined
  product: string
  urgency: Urgency
  image: ImageDetails
}

export type ImageDetails = {
  data: string | undefined
  name: string | undefined
}

export type MessageTypes = {id: string; label: string}
